import { useMemo, useState } from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material"
import { isUndefined } from "lodash"

import Icon from "@/components/icon/Icon"
import { colors } from "@/components/colors"

import "./settingSectionContainer.scss"

export default function SettingSectionContainer({
  id,
  title,
  children,
  isDragging,
  isLast,
  onDeleteSection,
}: {
  id: string
  title: string
  children?: React.ReactNode
  isDragging?: boolean
  isLast?: boolean
  onDeleteSection?: () => void
}) {
  const [open, setOpen] = useState(true)
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging: isInnerDragging,
    isOver,
  } = useSortable({ id })

  const openState = useMemo(() => {
    return isUndefined(isDragging) ? open : false
  }, [open, isDragging])

  if (isInnerDragging) {
    return <div className="SettingSectionDragOverOrigin" />
  }

  if (id === "__dummy__placeholder__") {
    if (isOver) {
      if (isLast) {
        return <div className="SettingSectionDragOver last-over" />
      }

      return <div className="SettingSectionDragOver" />
    } else {
      return <div ref={setNodeRef} className="SettingSectionDragOverOrigin dummy-invisible" />
    }
  }

  return (
    <>
      {isOver && <div className="SettingSectionDragOver" />}
      <Accordion
        className="SettingSectionCont"
        expanded={openState}
        ref={setNodeRef}
        style={{
          transform: CSS.Transform.toString(transform),
          transition,
        }}
        {...attributes}>
        <AccordionSummary className="SettingSectionHeaderCont">
          <div className="header-title-wrapper">
            <span className="icon-button-wrapper" {...listeners}>
              <Icon type="list-drag" size={24} color={colors.neutral.grey[600]} />
            </span>
            <p>{title}</p>
            {onDeleteSection && (
              <span className="icon-button-wrapper" onClick={onDeleteSection}>
                <Icon type="close" size={20} color={colors.neutral.grey[500]} />
              </span>
            )}
          </div>
          <span className="icon-button-wrapper" onClick={() => setOpen(!open)}>
            <Icon type={openState ? "arrow-up" : "arrow-down"} color={colors.neutral.grey[600]} />
          </span>
        </AccordionSummary>

        <AccordionDetails className="SettingSectionContentCont">{children}</AccordionDetails>
      </Accordion>
    </>
  )
}
